"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _gatsby = require("gatsby");

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _ModalRoutingContext = _interopRequireDefault(require("./ModalRoutingContext"));

var withoutPrefix = function withoutPrefix(path) {
  var prefix = typeof __BASE_PATH__ !== "undefined" ? __BASE_PATH__ : __PATH_PREFIX__;
  return path.slice(prefix ? prefix.length : 0);
};

var element = {};

function PageElementWrapper(_ref) {
  var _props$location$state2;

  var props = _ref.props,
      opts = _ref.opts;

  var modalContentRef = _react.default.useRef(null);

  var _React$useState = _react.default.useState({
    prevProps: null,
    lastModalProps: null,
    props: null,
    pathname: null
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var handleRequestClose = function handleRequestClose() {
    (0, _gatsby.navigate)(withoutPrefix(state.prevProps.location.pathname), {
      state: {
        noScroll: true
      }
    });
  };

  _react.default.useEffect(function () {
    var _state$prevProps, _props$location$state;

    if (((_state$prevProps = state.prevProps) === null || _state$prevProps === void 0 ? void 0 : _state$prevProps.location.pathname) !== props.location.pathname && (_props$location$state = props.location.state) !== null && _props$location$state !== void 0 && _props$location$state.modal && modalContentRef.current) {
      modalContentRef.current.scrollTop = 0;
    }
  });

  if (state.pathname !== (props === null || props === void 0 ? void 0 : props.location.pathname)) {
    var _state$props, _state$props$location;

    setState((0, _extends2.default)({
      pathname: props === null || props === void 0 ? void 0 : props.location.pathname,
      props: props
    }, (_state$props = state.props) !== null && _state$props !== void 0 && (_state$props$location = _state$props.location.state) !== null && _state$props$location !== void 0 && _state$props$location.modal ? {
      // Old page was a modal, keep track so we
      // can render the contents while closing
      lastModalProps: state.props
    } : {
      // Old page was not a modal, keep track so
      // we can render the contents under modals
      prevProps: state.props
    }));
  }

  var isModal = state.prevProps && ((_props$location$state2 = props.location.state) === null || _props$location$state2 === void 0 ? void 0 : _props$location$state2.modal);
  var resources = isModal ? state.prevProps.pageResources : props.pageResources; // The page is the previous path if this is a modal,
  // otherwise it's the current path

  element.page = /*#__PURE__*/_react.default.createElement(resources.component.default, (0, _extends2.default)({}, isModal ? state.prevProps : props, {
    key: resources.page.path
  }));

  if (isModal) {
    // Rendering the current page as a modal,
    // so create an element with the page contents
    element.modal = /*#__PURE__*/_react.default.createElement(props.pageResources.component.default, (0, _extends2.default)({}, props, {
      key: props === null || props === void 0 ? void 0 : props.pageResources.page.path
    }));
  } else if (state.lastModalProps) {
    // Not rendering the current page as a modal, but we may
    // be in the process of animating the old modal content
    // to close, so render the last modal content we have cached
    element.modal = /*#__PURE__*/_react.default.createElement(state.lastModalProps.pageResources.component.default, (0, _extends2.default)({}, state.lastModalProps, {
      key: state.lastModalProps.pageResources.page.path
    }));
  }

  var modalValues = _react.default.useMemo(function () {
    return {
      modal: isModal,
      closeTo: state.prevProps ? withoutPrefix(state.prevProps.location.pathname) : '/'
    };
  }, [isModal, state.prevProps]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, element.page, /*#__PURE__*/_react.default.createElement(_reactModal.default, (0, _extends2.default)({
    onRequestClose: handleRequestClose,
    contentRef: function contentRef(node) {
      modalContentRef.current = node;
    }
  }, opts === null || opts === void 0 ? void 0 : opts.modalProps, {
    isOpen: Boolean(isModal)
  }), element.modal ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: props === null || props === void 0 ? void 0 : props.location.key
  }, /*#__PURE__*/_react.default.createElement(_ModalRoutingContext.default.Provider, {
    value: modalValues
  }, element.modal)) : null));
}

var wrapPageElement = function wrapPageElement(context, opts) {
  return /*#__PURE__*/_react.default.createElement(PageElementWrapper, (0, _extends2.default)({}, context, {
    opts: opts
  }));
};

var _default = wrapPageElement;
exports.default = _default;